export default __webpack_public_path__ + "static/media/suite-montanha1-main.dff54489.webp";